import { z } from 'zod';

export const approveDeclineRequestSchema = z.object({
	approvePlayerRequest: z.boolean().optional(),
	declinePlayerRequest: z.boolean().optional()
});

export type ApproveDeclineRequestData = z.infer<typeof approveDeclineRequestSchema>;

export const approveDeclineTradeSchema = z.object({
	approveTrade: z.boolean().optional(),
	declineTrade: z.boolean().optional()
});

export type ApproveDeclineTradeData = z.infer<typeof approveDeclineTradeSchema>;

export const sendInvitationSchema = z.object({
	sendMail: z.boolean().optional(),
	sendSms: z.boolean().optional()
});

export type SendInvitationData = z.infer<typeof sendInvitationSchema>;

export const sendTextSchema = z.object({
	message: z.string().min(1, 'Message is required'),
	players: z.record(z.string(), z.boolean())
});

export type SendTextData = z.infer<typeof sendTextSchema>;
